import React from "react"

import moment from "moment"

import BaseTable from "./BaseTable"
import EditCell from "./cells/EditCell";

import OrderTerminalModal from "../modal/OrderTerminalModal";
import TerminalAssignmentModal from "../modal/TerminalAssignmentModal";
import TerminalModal from "../modal/TerminalModal";

import General from "../../../utils/General";
import Mode from "../../../utils/Mode";

const COMPANY_FILTER = {
  name: {
    api: 'company_id',
    label: 'Company',
  },
  endpoint: {
    url: window.Api.Companies,
    filters: `live=${!Mode.isDemoToggled()}`,
    orderBy: 'name',
    accessor: '',
  }
}
const FILTERS = [
  COMPANY_FILTER,
]

export default class TerminalsTable extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      live: props.live,
      company: props.company,
      mode: props.mode,
      terminals: [],
      selectedTerminals: []
    }

    this.table = React.createRef()
  }

  componentWillReceiveProps(nextProps, nextContext) {
    this.setState({
      ...nextProps,
      selectedTerminals: []
    }, () => this.table.current.refresh())
  }

  isAllSelected = () => {
    return this.state.terminals.length > 0 && this.state.selectedTerminals.length === this.state.terminals.length;
  }


  handleSelectAll = () => {
    if (this.isAllSelected()) {
      this.setState({ selectedTerminals: [] });
    } else {
      this.setState({
        selectedTerminals: this.state.terminals.map((t) => t.id),
      });
    }
  };

  handleSelectRow = (id) => {
    const { selectedTerminals } = this.state;
    if (selectedTerminals.includes(id)) {
      this.setState({
        selectedTerminals: selectedTerminals.filter(
          (sn) => sn !== id,
        ),
      });
    } else {
      this.setState({
        selectedTerminals: [...selectedTerminals, id],
      });
    }
  };

  _getColumns() {
    let {
      selectedTerminals
    } = this.state;

    return [
      {
        Header: (
          <input
            type="checkbox"
            checked={this.isAllSelected()}
            onChange={this.handleSelectAll}
            aria-label="Select all"
            className="checkbox"
          />
        ),
        accessor: "select",
        width: 40,
        sortable: false,
        resizable: false,
        Cell: (rowInfo) => {
          let terminal = rowInfo.original
          return (
            <input
              type="checkbox"
              checked={selectedTerminals.includes(terminal.id)}
              onChange={() => this.handleSelectRow(terminal.id)}
              aria-label="Select row"
              className="checkbox"
            />
          )
        }
      },
      {
        Header: 'Date',
        id: 'created_at',
        accessor: terminal => moment(terminal.created_at).format('DD MMM YYYY')
      },
      {
        Header: 'Company',
        id: 'store.company.name',
        accessor:  terminal => terminal.store?.company.name,
        Cell: (rowInfo) => {
          let terminal = rowInfo.original

          if(!terminal.store) return "-"

          return (
            <div className="d-flex align-items-center">
              <div className={"ml-2"}>
                <div className="text-dark-75 font-weight-bold line-height-sm">
                  {terminal?.store.company.name}
                </div>
                <a
                  href="javascript:;"
                  className="font-size-sm text-dark-50 text-hover-primary"
                >
                  {terminal.store.name}
                </a>
              </div>
            </div>
          )
        }
      },
      {
        Header: 'Status',
        id: 'external_status',
        accessor:  terminal => General.snakeCaseToTitleCase(terminal.external_status),
        Cell: (rowInfo) => {
          let terminal = rowInfo.original

          let className = "label label-lg font-weight-bold label-inline w-110px ";
          let status = ""

          if(terminal.store){
            className += "label-light-success";
            status = "In Store"
          }else {
            className += "label-light-dark";
            status = "Inventory"
          }

          return (
            <span className={className}>
              {status}
            </span>
          );
        }
      },
      {
        Header: 'Standalone',
        id: 'standalone',
        accessor:  terminal => terminal.standalone,
        Cell: (rowInfo) => {
          let terminal = rowInfo.original

          let className = "label label-lg font-weight-bold label-inline w-110px ";
          let status = ""

          if(terminal.standalone){
            className += "label-success";
            status = "True"
          }else {
            className += "label-warning";
            status = "False"
          }

          return (
            <span className={className}>
              {status}
            </span>
          );
        }
      },
      {
        Header: 'Device Name',
        id: 'name',
        accessor:  terminal => terminal.name
      },
      {
        Header: 'Serial No',
        id: 'serial_no',
        accessor:  terminal => terminal.serial_no
      },
      {
        Header: 'Region',
        id: 'region',
        accessor:  terminal => terminal.region.toUpperCase()
      },
      {
        Header: 'Assigned At',
        id: 'assigned_at',
        accessor: terminal => terminal.assigned_at ? moment(terminal.assigned_at).format('DD MMM YYYY') : "-"
      },
      {
        Header: 'Actions',
        id: 'status',
        sortable: false,
        exportable: false,
        Cell: rowInfo => {
          let terminal = rowInfo.original
          return (
            <span style={{overflow: 'visible', position: 'relative', width: 150}}>
              <EditCell
                onEditClicked={() => {
                  this.setState({
                    showTerminalModal: true,
                    selectedTerminal: terminal
                  })
                }}
              />
            </span>
          )
        }
      }
    ]
  }

  _renderToolBar(){
    return (
      <>
        <div className="buttons-grid">
          <button
            type="button"
            className="btn btn-outline-primary"
            disabled={this.state.selectedTerminals.length === 0}
            onClick={() => {
              this.setState({showTerminalAssignmentModal: true})
            }}
          >
            Reassign
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              this.setState({showOrderTerminalModal: true})
            }}
          >
            Order Terminal(s)
          </button>
        </div>
      </>
    )
  }

  _renderOrderTerminalModal(){
    let {
      live,
      showOrderTerminalModal,
    } = this.state

    if(!showOrderTerminalModal) return null

    return (
      <OrderTerminalModal
        show={showOrderTerminalModal}
        live={live}
        onSuccess={() => {
          this.setState({
            showOrderTerminalModal: false,
          })
          this.table.current.refresh()
        }}
        onHide={() => {
          this.setState({
            showOrderTerminalModal: false,
          })
        }}
      />
    )
  }

  _renderTerminalAssignmentModal(){
    let {
      selectedTerminals,
      showTerminalAssignmentModal,
    } = this.state

    if(!showTerminalAssignmentModal) return null

    return (
      <TerminalAssignmentModal
        show={showTerminalAssignmentModal}
        selectedTerminals={selectedTerminals}
        onSuccess={() => {
          this.setState({
            selectedTerminals: [],
            showTerminalAssignmentModal: false,
          })
          this.table.current.refresh()
        }}
        onHide={() => {
          this.setState({
            showTerminalAssignmentModal: false,
          })
        }}
      />
    )
  }

  _renderTerminalModal(){
    let {
      selectedTerminal,
      showTerminalModal,
    } = this.state

    if(!showTerminalModal) return null

    return (
      <TerminalModal
        show={showTerminalModal}
        terminal={General.clone(selectedTerminal)}
        onSuccess={() => {
          this.setState({
            showTerminalModal: false,
            selectedTerminal: null
          })
          this.table.current.refresh()
        }}
        onHide={() => {
          this.setState({
            showTerminalModal: false,
            selectedTerminal: null
          })
        }}
      />
    )
  }

  render() {
    let {
      company,
      mode,
    } = this.state

    const columns = this._getColumns()

    let endpoint = `${window.Api.Terminals}?company_id=${company?.id || ""}`

    if(mode === "inventory"){
      endpoint += `&assigned=false`
    }else if(mode === "assigned"){
      endpoint += `&assigned=true`
    }

    return (
      <div>
        <BaseTable
          ref={this.table}
          endpoint={`${endpoint}`}
          noDataMessage={"No Terminals Found"}
          title={"Terminals"}
          columns={columns}
          renderToolbar={() => this._renderToolBar()}
          filters={FILTERS}
          showExport={false}
          showHeader={true}
          defaultSorted={[
            {
              id: "created_at",
              desc: true
            }
          ]}
          onDataLoaded={(terminals) => {
            this.setState({terminals})
          }}
        />
        { this._renderOrderTerminalModal() }
        { this._renderTerminalAssignmentModal() }
        { this._renderTerminalModal() }
      </div>
    )
  }
}

TerminalsTable.defaultProps = {
  latestResults: false
}
